"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createVueComponent = _interopRequireDefault(require("../createVueComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Bluetooth = (0, _createVueComponent.default)('BluetoothIcon', [['path', {
  d: 'M7 7l10 10-5 5V2l5 5L7 17'
}]]);
var _default = Bluetooth;
exports.default = _default;